import { PartitionSelector } from "domains/partitions/components/partition-selector";
import { Typography } from "@mui/material";
import localisations from "../../../localisation";
import { useCallback } from "react";
import { SelectedPartitionDetails } from "domains/partitions/components/partition-selector/PartitionSelector";

type SelectSourcePartitionStageProps = {
    fieldCompanyId: number;
    fields: {
        sourcePartitionDetails?: SelectedPartitionDetails;
    };
    handleFieldChange: (fields: any) => void;
};

export default function SelectSourcePartitionStage(props: SelectSourcePartitionStageProps) {
    const { heading, blurb } = localisations.movementAllocation.stages.selectSourcePartition;
    const { fields, handleFieldChange } = props;

    return (
        <>
            <Typography variant="h5" gutterBottom>
                {heading}
            </Typography>

            <Typography variant="body1" gutterBottom>
                {blurb}
            </Typography>

            <br />
            <PartitionSelector
                fieldCompanyId={props.fieldCompanyId}
                initialPartitionId={fields.sourcePartitionDetails?.id}
                onSelected={useCallback((partitionDetails) => handleFieldChange({ sourcePartitionDetails: partitionDetails }), [handleFieldChange])}
            />

            <br />
            <br />
        </>
    );
}
